/**
© BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/

if (!customElements.get('blocky-before-after-slider')) {
  customElements.define('blocky-before-after-slider',
    class BlockyBeforeAfterSlider extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.sliderInput = null;
        
        // Bind methods
        this.init = this.init.bind(this);
        this.handleSliderInput = this.handleSliderInput.bind(this);
        
        // Listen for initialization event
        this.addEventListener('blocky:init', this.init);
      }
      
      connectedCallback() {
        if (this.initialized) return;
        this.init();
      }
      
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        this.sliderInput = this.querySelector(".blocky-before-after-slider-input");
        
        if (!this.sliderInput) {
          console.warn('Blocky Before/After Slider: No input element found');
          return;
        }
        
        // Set initial position
        this.updateSliderPosition(this.sliderInput.value);
        
        // Add event listener
        this.sliderInput.addEventListener("input", this.handleSliderInput);
      }
      
      handleSliderInput(e) {
        this.updateSliderPosition(e.target.value);
      }
      
      updateSliderPosition(sliderPos) {
        if (!this.sliderInput) return;
        
        const parentElement = this.sliderInput.closest('.blocky-before-after-slider-slider') || this;
        const afterImage = parentElement.querySelector(".blocky-before-after-after-image");
        const sliderLine = parentElement.querySelector(".blocky-before-after-slider-line");
        
        if (!afterImage || !sliderLine) {
          console.warn('Blocky Before/After Slider: Missing required elements');
          return;
        }
        
        // Update slider line position
        sliderLine.style.left = sliderPos + "%";
        
        // Update image width and position
        afterImage.style.width = `${100 - sliderPos}%`;
        
        const image = afterImage.querySelector("img, svg");
        if (image) {
          image.style.transform = `translate(-${sliderPos}%, 0)`;
        }
      }
      
      disconnectedCallback() {
        // Clean up event listeners
        if (this.sliderInput) {
          this.sliderInput.removeEventListener("input", this.handleSliderInput);
        }
      }
    }
  );
}
